import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
import i18n from './lang'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueCookies)
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
